const HERO_IMAGE_SETTINGS = {
  us: {
    imageFileName: 'bn-terms',
    imagePosition: '70%',
    imageTitle: 'images.terms.hero.title',
    imageAlt: 'images.terms.hero.alt',
  },
  ng: {
    imageFileName: 'bn-terms_ng',
    imagePosition: '70%',
    imageTitle: 'images.terms.hero.title.ng',
    imageAlt: 'images.terms.hero.alt.ng',
  },
  pl: {
    imageFileName: 'bn-terms',
    imagePosition: '70%',
    imageTitle: 'images.terms.hero.title',
    imageAlt: 'images.terms.hero.alt',
  },
  cz: {
    imageFileName: 'bn-terms',
    imagePosition: '70%',
    imageTitle: 'images.terms.hero.title',
    imageAlt: 'images.terms.hero.alt',
  },
};

export const usePrivacyHeroImage = (country) => HERO_IMAGE_SETTINGS[country] || HERO_IMAGE_SETTINGS.us;

export default usePrivacyHeroImage;
